{
  "Accessibility menu": "Saavutettavuusvalikko",
  "Reset settings": "Palauta asetukset",
  "Close": "Sulje",
  "Content adjustments": "Sisällön säädöt",
  "Navigation adjustments": "Navigoinnin säädöt",
  "Align Left": "Tasaa vasemmalle",
  "Adjust Font Size": "Säädä fonttikokoa",
  "Highlight Title": "Korosta otsikko",
  "Highlight Links": "Korosta linkit",
  "Readable Font": "Helposti luettava fontti",
  "Colour adjustments": "Värien säädöt",
  "Dark Contrast": "Tumma kontrasti",
  "Light Contrast": "Vaalea kontrasti",
  "High Contrast": "Korkea kontrasti",
  "High Saturation": "Korkea kylläisyys",
  "Low Saturation": "Matala kylläisyys",
  "Monochrome": "Yksivärinen",
  "Tools": "Työkalut",
  "Reading Guide": "Lukemisopas",
  "Stop Animations": "Pysäytä animaatiot",
  "Big Cursor": "Iso kohdistin",
  "Increase Font Size": "Suurenna fonttikokoa",
  "Decrease Font Size": "Pienennä fonttikokoa",
  "Letter Spacing": "Kirjainten välistys",
  "Line Height": "Rivin korkeus",
  "Font Weight": "Fontin paksuus",
  "Dyslexia Font": "Dysleksiafontti",
  "Language": "Kieli",
  "Accessibility widget": "Avaa saavutettavuusvalikko",
  "Accessibility Profiles": "Saavutettavuusprofiilit",
  "Cognitive Disability": "Kognitiivinen vamma",
  "Seizure Safe": "Turvallinen epilepsialle",
  "Accessibility statement": "Saavutettavuusseloste"
}
